import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {Chacra} from "../../../../../chacra-core/models/chacra";

export enum ChacrasActionTypes {
  CHACRAS_LOAD_REQUEST = '[CHACRAS] Load Request',
  CHACRAS_LOAD_FAILURE = '[CHACRAS] Load Failure',
  CHACRAS_LOAD_SUCCESS = '[CHACRAS] Load Success',
  CHACRAS_PADRONUPDATE_SUCCESS = '[CHACRAS] Padron Update Success',
  CHACRAS_GETPADRONES_REQUEST = '[CHACRAS] Get Padrones Request',
  CHACRAS_GETPADRONES_FAILURE = '[CHACRAS] Get Padrones Failure',
  CHACRAS_GETPADRONES_SUCCESS = '[CHACRAS] Get Padrones Success',
  CHACRAS_GETSUELOS_REQUEST = '[CHACRAS] Get Suelos Request',
  CHACRAS_GETSUELOS_FAILURE = '[CHACRAS] Get Suelos Failure',
  CHACRAS_GETSUELOS_SUCCESS = '[CHACRAS] Get Suelos Success',
  CHACRAS_GETLS_REQUEST = '[CHACRAS] Get LS Request',
  CHACRAS_GETLS_FAILURE = '[CHACRAS] Get LS Failure',
  CHACRAS_GETLS_SUCCESS = '[CHACRAS] Get LS Success',

  CHACRAS_GET_TIPO_LABOREO_REQUEST = '[CHACRAS] Get tipo laboreo Request',
  CHACRAS_GET_TIPO_LABOREO_FAILURE = '[CHACRAS] Get tipo laboreo Failure',
  CHACRAS_GET_TIPO_LABOREO_SUCCESS = '[CHACRAS] Get tipo laboreo Success',

  CHACRAS_GET_FACTOR_P_REQUEST = '[CHACRAS] Get factor p Request',
  CHACRAS_GET_FACTOR_P_FAILURE = '[CHACRAS] Get factor p Failure',
  CHACRAS_GET_FACTOR_P_SUCCESS = '[CHACRAS] Get factor p Success',

  CHACRAS_COPY_DIBUJO = '[CHACRAS] Copy dibujo',

  CHACRAS_CHANGE_PENDIENTE = '[CHACRAS] change pendiente',
}

// load
export class ChacrasLoadRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_LOAD_REQUEST;

  constructor(public from: string, public filter?: any) {}
}

export class ChacrasLoadFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_LOAD_FAILURE;
  constructor(public payload: { error: string }) {
  }
}

export class ChacrasLoadSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_LOAD_SUCCESS;
  constructor(public payload: { items: Chacra[], meta?: any }) {
  }
}

export class ChacrasPadronUpdateSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_PADRONUPDATE_SUCCESS;

  constructor(public payload: { items: Update<Chacra>[] }) {
  }
}

// get padrones

export class ChacrasGetPadronesRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETPADRONES_REQUEST;

  constructor(public payload: { item: Chacra }) {
  }
}

export class ChacrasGetPadronesFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETPADRONES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ChacrasGetPadronesSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETPADRONES_SUCCESS;

  constructor(public payload: { item: Update<Chacra> }) {
  }
}

// get suelos

export class ChacrasGetSuelosRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETSUELOS_REQUEST;

  constructor(public payload: { item: Chacra, loading?: boolean }) {
  }
}

export class ChacrasGetSuelosFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETSUELOS_FAILURE;

  constructor(public payload: { error: string, item: Update<Chacra> }) {
  }
}

export class ChacrasGetSuelosSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETSUELOS_SUCCESS;

  constructor(public payload: { item: Update<Chacra> }) {
  }
}

// get LS

export class ChacrasGetLSRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETLS_REQUEST;

  constructor(public payload: { item: Chacra, loading?: boolean }) {
  }
}

export class ChacrasGetLSFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETLS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ChacrasGetLSSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GETLS_SUCCESS;

  constructor(public payload: { item: Update<Chacra> }) {
  }
}

// get tipo laboreo
export class ChacrasGetTipoLaboreoRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_REQUEST;

  constructor(public rotacionId: string, public chacraId: string) {
  }
}

export class ChacrasGetTipoLaboreoFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ChacrasGetTipoLaboreoSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_TIPO_LABOREO_SUCCESS;

  constructor(public payload: { item: Update<Chacra> }) {
  }
}

// get factor p
export class ChacrasGetFactorPRequestAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_FACTOR_P_REQUEST;

  constructor(public payload: { item: Chacra }) {
  }
}

export class ChacrasGetFactorPFailureAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_FACTOR_P_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ChacrasGetFactorPSuccessAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_GET_FACTOR_P_SUCCESS;

  constructor(public payload: { factorP: any }) {
  }
}

export class ChacrasCopyDibujoAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_COPY_DIBUJO;

  constructor(public payload: { item: Chacra }) {
  }
}

export class ChacrasChangePendienteAction implements Action {
  readonly type = ChacrasActionTypes.CHACRAS_CHANGE_PENDIENTE;
  constructor(public payload: { item: Chacra }) {
  }
}

// actions

export type ChacrasActions =
  | ChacrasLoadRequestAction
  | ChacrasLoadFailureAction
  | ChacrasLoadSuccessAction
  | ChacrasPadronUpdateSuccessAction
  | ChacrasGetPadronesRequestAction
  | ChacrasGetPadronesFailureAction
  | ChacrasGetPadronesSuccessAction
  | ChacrasGetSuelosRequestAction
  | ChacrasGetSuelosFailureAction
  | ChacrasGetSuelosSuccessAction
  | ChacrasGetLSRequestAction
  | ChacrasGetLSFailureAction
  | ChacrasGetLSSuccessAction
  | ChacrasGetTipoLaboreoRequestAction
  | ChacrasGetTipoLaboreoFailureAction
  | ChacrasGetTipoLaboreoSuccessAction
  | ChacrasGetFactorPRequestAction
  | ChacrasGetFactorPFailureAction
  | ChacrasGetFactorPSuccessAction
  | ChacrasChangePendienteAction
  | ChacrasCopyDibujoAction;
